export default __webpack_public_path__ + "static/media/mochi-coin-circle.ff612791.svg";